export const emergencyPanelTranslations = {
    en: {
        'EMERGENCY_PANEL_TITLE': 'Emergency response',
        'EMERGENCY_EMPTY': 'There\'s no emergency plans',
        'EMERGENCY_SETTINGS': 'Setting emergency plans',
    },
    ru: {
        'EMERGENCY_PANEL_TITLE': 'ÐÐµÐ¹ÑÑÐ²Ð¸Ñ Ð¿ÑÐ¸ Ð§Ð¡',
        'EMERGENCY_EMPTY': 'ÐÐ»Ð°Ð½Ñ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ð¹ Ð¾ÑÑÑÑÑÑÐ²ÑÑÑ',
        'EMERGENCY_SETTINGS': 'ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿Ð»Ð°Ð½Ð¾Ð² Ð§Ð¡',
    }
};
